import { useNavigate } from 'react-router-dom';
import { Building2, Home, TrendingUp } from 'lucide-react';
import { useCurrency } from '@/contexts/CurrencyContext';
import { formatPriceRange } from '@/lib/formatPrice';
import { HorizontalCardRow, HorizontalListingCard, formatTimeAgo } from './HorizontalListingCard';
import { CompactContactActions } from '@/components/property/CompactContactActions';

interface Props { projects: any[]; }

export function TrendingProjectsTwoRow({ projects }: Props) {
  const navigate = useNavigate();
  const { displayCurrency, rate } = useCurrency();
  if (!projects.length) return null;

  return (
    <HorizontalCardRow title="Trending Projects" icon={<TrendingUp className="h-5 w-5 text-primary" />}>
      {projects.map((p: any) => {
        const name = typeof p.name === 'object' ? p.name?.en || '' : p.name || '';
        const img = p.project_images?.find((i: any) => i.is_primary)?.url || p.project_images?.[0]?.url;
        const priceRange = p.price_min ? formatPriceRange(p.price_min, p.price_max, p.currency || 'ETB', displayCurrency, rate) : 'Price on Request';
        const icons: Array<{ icon: React.ReactNode; label: string | number }> = [];
        icons.push({ icon: <Home className="h-3 w-3" />, label: (p.status || 'Project').replace(/_/g,' ') });
        if (p.total_units) icons.push({ icon: <Building2 className="h-3 w-3" />, label: `${p.available_units || p.total_units} units` });
        const phone = p.developer_profiles?.phone || p.agencies?.phone || p.contact_phone;
        const agentName = p.developer_profiles?.company_name || p.agencies?.name || 'Project Team';
        return (
          <HorizontalListingCard
            key={p.id}
            imageUrl={img}
            hot={!!p.is_featured}
            topRightChip={formatTimeAgo(p.created_at)}
            priceLabel={priceRange}
            title={`${p.city}${p.sub_city ? `, ${p.sub_city}` : ''} — ${name}`}
            subtitleLink="New Project"
            icons={icons}
            onClick={() => navigate(`/projects/${p.slug || p.id}`)}
            onSubtitleClick={() => navigate(`/projects/${p.slug || p.id}`)}
            footer={
              <div className="pt-2 mt-1 border-t">
                <CompactContactActions
                  phone={phone}
                  agentName={agentName}
                  agencyName={p.agencies?.name}
                  agentLogo={p.agencies?.logo_url || p.developer_profiles?.logo_url}
                  referenceId={p.reference_code || `ID${String(p.id).slice(0,8)}`}
                  projectId={p.id}
                  listingType="project"
                />
              </div>
            }
          />
        );
      })}
    </HorizontalCardRow>
  );
}
